import { Alert, Box, Collapse, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import Capa from "../../Controls/Capa/Capa";
import { getLeyendaList } from "../../../Service/leyenda";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { getImageTipoList, getPosicionFirmaList } from "../../../Service/imagen";
import { addLeyendaFirma, FrmUpdateLeyendaFirmasSoc } from "../../../Service/leyendasFirma";

export default function LeyendaFirmaView(props) {

    const { accessToken } = useContext(AuthContext);
    const [leyendas, setLeyendas] = useState([]);
    const [firmas, setFirmas] = useState([]);
    const [posiciones, setPosiciones] = useState([]);
    const [loading, setLoading] = useState(false);

    const [valCodLeyendaFirma, setCodLeyendaFirma] = useState('')

    const [valLeyenda, setLeyenda] = useState('')
    const [valLogo, setLogo] = useState('')
    const [valPosicion, setPosicion] = useState('')

    //DIALOG METODOS MSJ ********************
    //Open Close
    const [openMsj, setOpenMsj] = useState(false)
    //Msj Error
    const [msjTitle, setMsjTitle] = useState("")

    const MsjElement = ({ severityProp }) => {
        return (
            <Collapse in={openMsj}>
                <Alert severity={severityProp} onClose={() => { setOpenMsj(false) }}>
                    {msjTitle}
                </Alert>
            </Collapse>
        );
    };

    //DIALOG METODOS MSJ ********************




    useEffect(() => {

        setLoading(true);
        getLeyendaList(accessToken)
            .then((data) => {
                setLeyendas(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getImageTipoList(accessToken, 'F')
            .then((data) => {
                setFirmas(data);
            })
            .catch()
            .finally(() => setLoading(false))

        setLoading(true);

        getPosicionFirmaList(accessToken)
            .then((data) => {
                setPosiciones(data);
            })
            .catch()
            .finally(() => setLoading(false))

        if (props.dataEdit != undefined && props.dataEdit.CodLeyendaFirma != 0) {

            setCodLeyendaFirma(props.dataEdit.CodLeyendaFirma);
            setLeyenda(props.dataEdit.CodLeyenda);
            setLogo(props.dataEdit.stream_id);
            setPosicion(props.dataEdit.CodFirmaPosicion);

        }

    }, []);

    const leyendaChange = (event) => {
        setLeyenda(event.target.value);
    };

    const logoChange = (event) => {
        setLogo(event.target.value);
    };

    const PosicionChange = (event) => {
        setPosicion(event.target.value);
    };

    const onAceptar = (e) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        //tomo las descripciones para ser mostradas en la grilla
        const selectedLeyenda = leyendas.find((option) => option.CodLeyenda == formData.get("CodLeyenda"))?.DescLey;
        const selectedFirma = firmas.find((option) => option.stream_id == formData.get("stream_id"))?.Descripcion;
        const selectedPosicion = posiciones.find((option) => option.CodImgPosicion == formData.get("CodFirmaPosicion"))?.Descripcion;


        if (props.dataEdit != undefined && props.dataEdit.CodLeyendaFirma != undefined && props.dataEdit.CodLeyendaFirma != 0) {
            //Edit
            const frmUpdateLeyendasFirmasSocRequest = Object.fromEntries(formData);
            const datos = { frmUpdateLeyendasFirmasSocRequest }
            datos.frmUpdateLeyendasFirmasSocRequest.CodLeyendaFirma = props.dataEdit.CodLeyendaFirma;
            FrmUpdateLeyendaFirmasSoc(datos, accessToken)
                .then(data => {
                    if (data != undefined && data.Message != undefined && data.Message.includes("Error")) {
                        setMsjTitle(data.Message);
                        setOpenMsj(true);
                        return;
                    } else {
                        //const dataNew = { ...datos.frmUpdateLeyendasFirmasSocRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedFirma, DescPosicion: selectedPosicion, CodLeyendaFirma: props.dataEdit.CodLeyendaFirma };
                        //props.setData(dataNew);
                        props.pInit();
                        props.handleClose();
                    }
                }).catch(
                    error => {
                        setMsjTitle(error.toString());
                        setOpenMsj(true);
                    });

        } else {
            //New

            const frmInsertLeyendasFirmasSocRequest = Object.fromEntries(formData);
            const datos = { frmInsertLeyendasFirmasSocRequest }

            addLeyendaFirma(datos, accessToken)
                .then(data => {


                    if (data.Message != undefined && data.Message.includes("Error")) {
                        setMsjTitle(data.Message);
                        setOpenMsj(true);
                        return;
                    } else {
                        //const dataNew = { ...datos.frmInsertLeyendasFirmasSocRequest, DescLeyenda: selectedLeyenda, DescImagen: selectedFirma, DescPosicion: selectedPosicion, CodLeyendaFirma: data.CodLeyendaFirma };
                        //props.setData(dataNew);
                        props.pInit();
                        props.handleClose();
                    }
                }).catch(
                    error => {
                        setMsjTitle(error.toString());
                        setOpenMsj(true);
                    });
        }



    }


    return (
        <Box component={'form'} onSubmit={onAceptar}>
            <Capa onCancel={props.handleClose} title={"Leyenda - Firma"}>
                <FormControl fullWidth required>
                    <InputLabel id="leyenda-select-label">Leyenda</InputLabel>
                    <Select
                        labelId="leyenda-select-label"
                        id="leyenda-select"
                        value={valLeyenda}
                        label="Leyenda"
                        onChange={leyendaChange}
                        sx={{ m: 1 }}
                        name="CodLeyenda"
                    >
                        {leyendas.map((option) => (
                            <MenuItem key={option.DescLey} value={option.CodLeyenda}>
                                {option.DescLey}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth required>
                    <InputLabel id="firma-select-label">Logo</InputLabel>
                    <Select
                        labelId="firma-select-label"
                        id="firma-select"
                        value={valLogo}
                        label="Firma"
                        onChange={logoChange}
                        sx={{ m: 1 }}
                        name="stream_id"
                    >
                        {firmas.map((option) => (
                            <MenuItem key={option.Descripcion} value={option.stream_id}>
                                {option.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl fullWidth required>
                    <InputLabel id="posicion-select-label">Posición</InputLabel>
                    <Select
                        labelId="posicion-select-label"
                        id="posicion-select"
                        value={valPosicion}
                        label="Posicion"
                        onChange={PosicionChange}
                        sx={{ m: 1 }}
                        name="codFirmaPosicion"
                    >
                        {posiciones.map((option) => (
                            <MenuItem key={option.Descripcion} value={option.CodFirmaPosicion}>
                                {option.Descripcion}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <MsjElement severityProp="error"></MsjElement>
            </Capa>

        </Box>
    );

};